import Icon from "~/components/ui/Icon"

export default function Orders() {
    return (
        <a
            href='/account#/orders'
            className='flex items-center max-lg:bg-white max-lg:text-black max-lg:w-full max-lg:text-base max-lg:px-2 max-lg:h-16 max-lg:gap-2 lg:flex-col lg:justify-center lg:gap-1'
        >
            <Icon id='Pedidos' size={24} className='lg:w-9 lg:h-9 lg:text-orange' />
            <span className='lg:font-bold lg:text-xs'>Meus Pedidos</span>
        </a>
    )
}
